import { render } from "./criteria-additional-interests.vue?vue&type=template&id=24886645&scoped=true&ts=true"
import script from "./criteria-additional-interests.vue?vue&type=script&lang=ts"
export * from "./criteria-additional-interests.vue?vue&type=script&lang=ts"

import "./criteria-additional-interests.vue?vue&type=style&index=0&id=24886645&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24886645"]])

export default __exports__